import React, {useContext} from 'react';
import SimpleContext from '../context/SimpleContext';
import {Link, withRouter} from "react-router-dom";
import logoApi from "../img/logoApi.png"
import logoApiActive from "../img/logoApiActive.png"
import footerSearch from "../img/footerSearch.png"
import footerSearchActive from "../img/footerSearchActive.png"
import BrandIcon from "../img/BrandIcon.png"
import BrandIconAvtive from "../img/BrandIconAvtive.png"
import Basket from "../img/Basket.png"
import BasketActive from "../img/BasketActive.png"
import Tarh from "../img/Tarh.png"
import TarhActive from "../img/TarhActive.png"


const Footer = props => {
    const context = useContext(SimpleContext);

    return (  
        <div className="pagination">
            <div className="toolBar">
                <ul style={{width:'100%'}} className="nav">
                    
                    <li className="nav-item">
                        <Link style={{textDecoration:'none'}} to="/"
                            
                            >
                            <img style={{width:'35px'}} className='iconFooter' src={props.location.pathname === "/"?logoApiActive:logoApi} />
                            <p className={props.location.pathname === "/"?"LinkP":"LinkActiveP"} style={{fontSize:"11px", fontFamily:"Vazir"}}>ویترین</p>
                        </Link> 
                    </li>
                    <li className="nav-item">
                        <Link onClick={()=>context.setshowCat(false)} style={{textDecoration:'none'}} to="/Categories"  
                           
                            >
                            <img className='iconFooter' src={props.location.pathname === "/Categories"?footerSearchActive:footerSearch} />
                            <p className={props.location.pathname === "/Categories"?"LinkP":"LinkActiveP"} style={{fontSize:"11px", fontFamily:"Vazir"}}>دسته بندی</p>
                        </Link>
                    </li >
                    <li className="nav-item">
                        <Link style={{textDecoration:'none',position:'relative'}} to="/Buy"  
                         
                            >
                            <img className='iconFooter' src={props.location.pathname === "/Buy"?BasketActive:Basket} />
                            <p className={props.location.pathname === "/Buy"?"LinkP":"LinkActiveP"} style={{fontSize:"11px", fontFamily:"Vazir"}}>سبدخرید</p>
                            {
                            context.BadgeOfBasket>0&&
                            <div style={{position:"absolute",bottom:"30px",
                            borderRadius:"50px",backgroundColor:"#ff7014",justifyContent:"center",textAlign:'center',alignItems:"center",
                            color:"#fff",fontSize:'14px',left:"20%",height:"22px",width:"22px",height:"20px",display:'flex'}}>
                                <span style={{margin:"0"}}>
                                  {context.BadgeOfBasket}
                                </span>
                            </div>
                            }
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link style={{textDecoration:'none'}} to="/Brands"   
                          
                            >
                            <img className='iconFooter' src={props.location.pathname === "/Brands"?BrandIconAvtive:BrandIcon} />
                            <p className={props.location.pathname === "/Brands"?"LinkP":"LinkActiveP"} style={{fontSize:"11px", fontFamily:"Vazir"}}>برند</p>
                        </Link>
                    </li>
                    <li  className="nav-item">
                        <Link style={{textDecoration:'none'}} to="/tarhha"  
                           
                            >
                            <img style={{width:"20px"}} className='iconFooter' src={props.location.pathname === "/tarhha"?TarhActive:Tarh} />
                            <p className={props.location.pathname === "/tarhha"?"LinkP":"LinkActiveP"} style={{fontSize:"11px", fontFamily:"Vazir"}}>طرح</p>
                        </Link>
                    </li>
                </ul>

            </div>
        </div>
    )
}
 
export default withRouter(Footer);